import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { MODULE_ROUTES } from '../constants/module-routes.const';
import { AuthService } from '../services/auth.service';

export const loginProfileSwitchGuard: CanActivateFn = async (route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const iid = route.queryParams.iid;
  
  if (!authService.isLoggedIn() || !iid) {
    return true;
  }
  
  const databaseId = Number(iid);
  
  if (authService.currentProfile?.DatabaseId === databaseId) {
    // already on the correct profile, redirect to login
    return router.createUrlTree(['/', MODULE_ROUTES.LOGIN]);
  }
  
  try {
    const userInfo = await firstValueFrom(authService.getCurrentUser());
    const targetProfile = userInfo?.Profiles?.find(
      p => p.DatabaseId === databaseId
    );
    
    if (targetProfile) {
      // switch to the tenant profile
      await authService.setCurrentProfile(targetProfile.DatabaseId, targetProfile.ProfileId);

      // Use href to navigate and reload in one step, removing iid param and clearing tenant cache
      window.location.href = `/${MODULE_ROUTES.LOGIN}`;
      return false;
    } else {
      console.warn(`User does not have access to instance ${iid}, using default profile`);
    }
  } catch (error) {
    console.error('Unable to switch profile, using default profile', error);
  }
  
  return router.createUrlTree(['/', MODULE_ROUTES.LOGIN]);
};
